import { Col, Typography } from "antd";

import CustomRow from "../../shared/costum-row/costum-row";

import "./styles.scss";

const { Title, Text } = Typography;

type ServiceType = {
  title: string;
  description: string;
};

const Service = ({ title, description }: ServiceType) => {
  return (
    <>
      <div className="Service-divider"></div>
      <CustomRow className="Service" justify={"space-between"} gutter={[0, 20]}>
        <Col xxl={6} xl={7} lg={9} md={9} sm={24} xs={24}>
          <Title className="Service-title">{title}</Title>
        </Col>
        <Col
          xxl={6}
          xl={7}
          lg={9}
          md={9}
          sm={24}
          xs={24}
          className="Service-description-container"
        >
          <Text className="Service-description">{description}</Text>
        </Col>
      </CustomRow>
    </>
  );
};

export default Service;
